import { render, staticRenderFns } from "./ChooseSeat.vue?vue&type=template&id=2ee62f05&scoped=true"
import script from "./ChooseSeat.vue?vue&type=script&lang=js"
export * from "./ChooseSeat.vue?vue&type=script&lang=js"
import style0 from "./ChooseSeat.vue?vue&type=style&index=0&id=2ee62f05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee62f05",
  null
  
)

export default component.exports